var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconContactEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#4F4DD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8332 21.3333L27.4998 30.2917L13.1665 21.3333V39.25H41.8332V21.3333ZM41.8332 17.75H13.1665L27.4998 26.6904L41.8332 17.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.1668 42.8333H41.8335C43.8043 42.8333 45.4168 41.2208 45.4168 39.25V17.75C45.4168 15.7792 43.8043 14.1667 41.8335 14.1667H13.1668C11.196 14.1667 9.5835 15.7792 9.5835 17.75V39.25C9.5835 41.2208 11.196 42.8333 13.1668 42.8333ZM41.8335 17.75L27.5002 26.6904L13.1668 17.75H41.8335ZM13.1668 21.3334L27.5002 30.2917L41.8335 21.3334V39.25H13.1668V21.3334Z",
    fill: "#4F4DD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactEmail);
export default __webpack_public_path__ + "static/media/icon-contact-email.8a214e2ddce36ac912275b34385fd0e2.svg";
export { ForwardRef as ReactComponent };